import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ai from '../assets/ai.png';
import { useTranslation } from 'react-i18next';
import { logout } from '../services/authService';
import { useAuth } from '../context/AuthContext';
function Home() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen p-4 bg-neutral-50 font-sans text-gray-800">
      <header className="flex flex-col md:flex-row justify-between items-center py-6 border-b border-gray-200 bg-white shadow-sm">
        <div className="flex items-center space-x-4 mx-4 px-6">
          <h1 className="text-4xl font-extrabold text-gray-900 text-center md:text-left">
            ZhadigerAI💎{' '}
          </h1>
          {/* <Link
            to="/about"
            className="text-xl font-bold text-gray-900 md:text-left pb-1 pl-3 underline"
          >
            {t("about")}{" "}
          </Link>
          <Link
            to="/pipelines"
            className="text-xl font-bold text-gray-900 md:text-left pb-1 pl-2 underline"
          >
            {t("pipeline")}{" "}
          </Link>
          <Link
            to="/about"
            className="text-xl font-bold text-gray-900 md:text-left pb-1 pl-2 underline"
          >
            {t("models")}{" "}
          </Link> */}
        </div>
        <nav className="mt-4 md:mt-0 flex space-x-6 mx-4">
          {!isAuthenticated && (
            <Link
              to="/login"
              className="px-4 py-2 text-lg text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors"
            >
              {t('login')}{' '}
            </Link>
          )}
          {isAuthenticated && (
            <button
              onClick={() => {
                logout();
                window.location.reload();
              }}
              className="px-4 py-2 text-lg text-red-600 border border-red-600 rounded-xl hover:bg-red-600 hover:text-white transition-colors"
            >
              {'Logout'}{' '}
            </button>
          )}
          <Link
            to="/register"
            className="px-4 py-2 text-lg text-blue-600 border border-blue-600 rounded-xl hover:bg-blue-600 hover:text-white transition-colors"
          >
            {t('register')}{' '}
          </Link>
        </nav>
      </header>

      <section className="relative h-[430px] mt-6 rounded-lg overflow-hidden shadow-lg">
        <img src={ai} className="w-full h-[430px] object-cover" alt="AI" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/70 to-transparent flex flex-col justify-center p-6 md:p-12">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 max-w-lg leading-tight">
            {t('ai_services')}{' '}
          </h1>
          <p className="mt-4 text-lg md:text-xl max-w-xl font-medium text-gray-700">
            {t('goal')}{' '}
          </p>
        </div>
      </section>

      <div className="my-12 text-center">
        <h2 className="text-4xl font-extrabold mb-8 text-gray-900">
          {t('our_services')}{' '}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-6">
          <Link
            to="/text-to-speech"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('text_to_speech')}{' '}
            </h3>
            <p className="text-gray-600">{t('text_to_speech_desc')} </p>
          </Link>

          <Link
            to="/named-entity-recognition"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('named_entity_recognition')}{' '}
            </h3>
            <p className="text-gray-600">
              {t('named_entity_recognition_desc')}{' '}
            </p>
          </Link>

          <Link
            to="/llm"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('llm')}{' '}
            </h3>
            <p className="text-gray-600">{t('llm_desc')} </p>
          </Link>

          <Link
            to="/speech-to-text"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('speech_to_text')}{' '}
            </h3>
            <p className="text-gray-600">{t('speech_to_text_desc')} </p>
          </Link>
          <Link
            to="/ocr"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('ocr')}{' '}
            </h3>
            <p className="text-gray-600">
              {t('optical_character_recognition_desc')}{' '}
            </p>
          </Link>
          <Link
            to="/imgcaptioning"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('image_captioning')}{' '}
            </h3>
            <p className="text-gray-600">{t('image_captioning_desc')} </p>
          </Link>
          <Link
            to="/kazclip"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              KazClip
            </h3>
            <p className="text-gray-600"></p>
          </Link>
          <Link
            to="/text-summarization"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('text_summarization')}{' '}
            </h3>
            <p className="text-gray-600">{t('text_summarization_desc')} </p>
          </Link>
          <Link
            to="/qa"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('qa')}{' '}
            </h3>
            <p className="text-gray-600">{t('question_answering_desc')} </p>
          </Link>
          <Link
            to="/machine-translation"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              {t('machine_translation')}{' '}
            </h3>
            <p className="text-gray-600">{t('machine_translation_desc')} </p>
          </Link>
          <Link
            to="/video-clip"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              Video Clip
            </h3>
            <p className="text-gray-600"></p>
          </Link>
          <Link
            to="/ocr-document-search"
            className="group block p-6 bg-white border rounded-lg shadow-lg hover:shadow-xl transition-shadow transform hover:scale-105"
          >
            <h3 className="text-2xl font-semibold mb-2 group-hover:text-blue-600 transition-colors">
              Document intelligence
            </h3>
            <p className="text-gray-600">{t('ocrr')}</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
